module.exports = __webpack_public_path__ + "img/44_41.f79479a2.png";